import MasterCard from 'assets/images/mastercard.svg';
import Visa from 'assets/images/visa.svg';
import UnionPay from 'assets/images/unionPay.svg';
import AmericanExpress from 'assets/images/americanExpress.svg';
import Discover from 'assets/images/discover.svg';
import DinersClub from 'assets/images/dinersClub.svg';
import Jcb from 'assets/images/jcb.svg';
import CountryAutocomplete from '../components/system/CountryAutocomplete';
import Input from '../components/system/Input';

export const attachCardFormInputs = [
  {
    name: 'name',
    label: 'Name',
    grid: 12,
    component: Input,
  },
  {
    name: 'line1',
    label: 'Address',
    grid: 12,
    component: Input,
  },
  {
    name: 'line2',
    label: 'Apt, suite, etc.',
    grid: 12,
    component: Input,
  },
  {
    name: 'country',
    label: 'Country*',
    grid: 12,
    component: CountryAutocomplete,
  },
  {
    name: 'state',
    label: 'State',
    grid: 6,
    component: Input,
  },
  {
    name: 'city',
    label: 'City',
    grid: 6,
    component: Input,
  },
];

export const attachBillingDetailsFormInputs = [...attachCardFormInputs, {
  name: 'postalCode',
  label: 'Zip Code',
  grid: 6,
  component: Input,
}];

export const cardBrandDetails = {
  mastercard: {
    logo: MasterCard,
    label: 'Mastercard',
  },
  visa: {
    logo: Visa,
    label: 'Visa',
  },
  unionpay: {
    logo: UnionPay,
    label: 'UnionPay',
  },
  amex: {
    logo: AmericanExpress,
    label: 'AmericanExpress',
  },
  discover: {
    logo: Discover,
    label: 'Discover',
  },
  diners: {
    logo: DinersClub,
    label: 'DinersClub',
  },
  jcb: {
    logo: Jcb,
    label: 'JCB',
  },
};
